import React, { useEffect, useRef } from 'react';

import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

import { useDebouncedCallback } from 'use-debounce';

import './FilterInput.scss';

export interface IFilterInputProps {
    filterText: string;
    setFilterText: React.Dispatch<React.SetStateAction<string>>;
}

export const FilterInput = ({ filterText, setFilterText }: IFilterInputProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    // Set initial value from props and ensure it's always in sync
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.value = filterText;
        }
    }, [filterText]);

    const debounced = useDebouncedCallback(
        (value) => {
            setFilterText(value || '');
        },
        // delay in ms
        500
    );

    return (
        <div className="filter-input-div">
            <Row spacing="300">
                <Text className="filter-input-label">Filter</Text>
                <input
                    className="filter-input"
                    type="text"
                    ref={inputRef}
                    defaultValue={filterText}
                    onChange={(e) => debounced(e.target.value)}
                />
            </Row>
        </div>
    );
};
